(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9741],{

/***/ 10127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/credit-bureau-consolidation",
      function () {
        return __webpack_require__(33806);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3861:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Cortera.9c4eda14.png","height":268,"width":1050,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEWOydzK5vDX7POf0eLg6OfHz8au2Of49/NBcuRTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYmJkZGRkYWVgZmZgY2BgYAcAAToAJZA0n68AAAAASUVORK5CYII="});

/***/ }),

/***/ 67638:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Creditsafe.99193bc8.png","height":50,"width":252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEXlNy7kOi7jOCzkOSriODF4s487AAAABXRSTlM0FU4/JO/U0X0AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BkZGFgZGZmYmBgYGZmYmJiBAABCQAdVm2urQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 90887:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Equifax.f41cfa8b.png","height":40,"width":205,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEWzJUCzJUCyJECyJECxJUGxJD+yJT+yJj6zJEC3JUMg3OPaAAAACnRSTlOkSleCbTiQNYqyhh2xIwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxj4GRg5mBgY2BhYGJkZmJkZWIHAAIJADZTrDwDAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 88307:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Experian.bdd3a34e.png","height":80,"width":241,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUUZogdSYsmRYsqRowlRYxQVp8mRYuXNYRlKnz6ipDiAAAACXRSTlMDGAtjVVs4MnFlJc0fAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVR4nAXBgQEAAATDsM4w/18sYQYo4Ozu9ZJIKvEDugBG5eX2XQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 3579:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/TransUnion.15f30321.png","height":60,"width":230,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEUAotMApskApsoApMc0hX6sAAAABHRSTlMDVUgrX00ZYgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABZJREFUeJxjYAADZkYGRiYmRkZGRmYAAHAAEXa6VusAAAAASUVORK5CYII="});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 33806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ credit_bureau_consolidation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/TitleSection.jsx
var TitleSection = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/DataPartners.jsx
var DataPartners = __webpack_require__(83570);
// EXTERNAL MODULE: ./src/landingPage/datasets/usecases/creditbureau.js + 5 modules
var creditbureau = __webpack_require__(46172);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Recipes.jsx + 1 modules
var Recipes = __webpack_require__(41974);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/CreditBureau/CreditBureau.jsx





// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";
var CreditBureau = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "credit_bureau_landing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection/* default */.Z, {
                data: creditbureau/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Recipes/* default */.Z, {
                data: creditbureau/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataPartners/* default */.Z, {
                dataPartners: creditbureau/* default.dataPartners */.Z.dataPartners
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/use-cases/credit-bureau-consolidation.jsx




var CreditBureauPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/use-cases/credit-bureau-consolidation",
                title: meta/* meta.usecases.creditbureau.title */.$.usecases.creditbureau.title,
                description: meta/* meta.usecases.creditbureau.description */.$.usecases.creditbureau.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditBureau, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var credit_bureau_consolidation = (CreditBureauPage);


/***/ }),

/***/ 46172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ creditbureau; }
});

// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Equifax.png
var Equifax = __webpack_require__(90887);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Experian.png
var Experian = __webpack_require__(88307);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/TransUnion.png
var TransUnion = __webpack_require__(3579);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Illion.png
/* harmony default export */ var Illion = ({"src":"/_next/static/media/Illion.2abde6a3.png","height":449,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAIVBMVEX////++/379vniwt3u2ufz5/Hw4+7+4879yaLonpr2n5gPougzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nD3KOQIAEBAEwbnW4v8PlqCTShr48apNlUjM5RG70AklvQE4CHQAWojYYvYAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Cortera.png
var Cortera = __webpack_require__(3861);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Creditsafe.png
var Creditsafe = __webpack_require__(67638);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Corelogic.png
/* harmony default export */ var Corelogic = ({"src":"/_next/static/media/Corelogic.acbc7b92.png","height":500,"width":900,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEX////9+fn+/Pzw7uz40M/m4+HXenX+7u7Mwb2sn5j/4eDuhYK9CEV3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgZGeAADZuBkZGJiYmBk4OLhYWZlZmEBckwAQABlEAXT1vOjQAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Verisk.png
/* harmony default export */ var Verisk = ({"src":"/_next/static/media/Verisk.2e34ab5f.png","height":340,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEVXXWFTVVZXVVdTV1p2r9I5aIVdochansOPvdfxJM2UAAAACXRSTlM7UGhh3izg2NfVQuFrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAF0lEQVR4nGNgZ2FgZAABDjZWJmZGJmYAAX8AK+ZMINwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/LexisNexis.svg
/* harmony default export */ var LexisNexis = ({"src":"/_next/static/media/LexisNexis.ba9c0f5e.svg","height":239,"width":1024});
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Microbilt.png
/* harmony default export */ var Microbilt = ({"src":"/_next/static/media/Microbilt.dddfd8ac.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEX////l7/je7vjt9frOzre6zMTNyMkDNjnPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVR4nGNgwA1Y2JiZGBmZGBlYWMEMZjxqAQYuACq1DW9SAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/landingPage/datasets/usecases/creditbureau.js










var data = {
    usecaseInfo: {
        name: "Optimize Credit Decisioning",
        description: "A single platform to integrate and manage credit bureau feeds globally."
    },
    recipesInfo: {
        title: "Make credit decisions",
        description: "Access API-ready solutions for consumer credit, business credit, and property risk available from bureaus in every region of the world."
    },
    recipes: [
        {
            type: "People Data",
            title: "US Consumer Bureau",
            description: "Access US consumer bureau data from three leading data products: Equifax, Experian, and Transunion "
        },
        {
            type: "Business Data",
            title: "Business Financials",
            description: "Demyst's Business Financials Product provides access to business credit information, firmographics, liens, and judgments, about a business to expedite business underwriting."
        },
        {
            type: "Other Data",
            title: "...And Many More",
            description: "Access 100's of api-ready recipes.",
            ctaText: "Access Recipe Catalog"
        }, 
    ],
    dataPartners: {
        title: "Sample Data Providers",
        description: "Access to hundreds of data partners worldwide",
        logos: [
            {
                name: "Equifax",
                img: Equifax/* default */.Z
            },
            {
                name: "Experian",
                img: Experian/* default */.Z
            },
            {
                name: "TransUnion",
                img: TransUnion/* default */.Z
            },
            {
                name: "Illion",
                img: Illion
            },
            {
                name: "Cortera",
                img: Cortera/* default */.Z
            },
            {
                name: "Creditsafe",
                img: Creditsafe/* default */.Z
            },
            {
                name: "Corelogic",
                img: Corelogic
            },
            {
                name: "Verisk",
                img: Verisk
            },
            {
                name: "LexisNexis",
                img: LexisNexis
            },
            {
                name: "Microbilt",
                img: Microbilt
            }, 
        ]
    },
    resourcesInfo: {
        title: "Resources",
        description: "The latest news, technologies, and resources from our team."
    },
    resources: [
        {
            title: "Addressing Data Decay in Phone Numbers",
            url: "https://demyst.com/blog/what-happens-to-a-business-when-phone-numbers-are-inaccurate",
            featured_image: "https://cdn.buttercms.com/H4dlSKqhScyxR0M65gY6",
            date: "2021-10-9",
            description: "Phone numbers are a crucial component of marketing, customer relations, and account management. Indeed, apart from outbound email campaigns and Linkedin outreach, many organizations depend on phone calls for cold outreach campaigns. But in the B2B space, these records are continually changing, which can cause problems for the marketing campaigns that rely on them.",
            more: ""
        }, 
    ]
};
/* harmony default export */ var creditbureau = (data);


/***/ }),

/***/ 38828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11723);



/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "usecases_title_section",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "usecases_title_section-container section-layout",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "usecases_title_section-text_container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: data.usecaseInfo.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "usecases_title_section-description",
                            children: data.usecaseInfo.description
                        }),
                        data.usecaseInfo.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, {
                            download: data.usecaseInfo.button.download,
                            href: data.usecaseInfo.button.url,
                            variant: "inverted",
                            demystIcon: true,
                            children: data.usecaseInfo.button.text
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__/* .MainCtaButton */ .T, {})
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        },
        isExternal: isExternal
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,1065,9774,2888,179], function() { return __webpack_exec__(10127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);